<template>
  <report-section title="睡眠时间占比" class="time-period-chart-section">
    <template v-slot:content>
      <div>
        <div class="sleep-pie-chart" :id="title"></div>
      </div>
    </template>
  </report-section>
</template>
            
<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      title: "timePeriodChart",
      // 颜色顺序：浅睡(浅蓝)、清醒(红)、REM(深蓝)、深睡(灰蓝)
      colorArray: ["#77B2DD", "#F12C2D", "#AEDEFF", "#0270C1"],
    };
  },
  
  mounted() {
    this.$nextTick(() => {
      if (document.getElementById(this.title)) {
        this.chart = this.$echarts.init(document.getElementById(this.title));
        this.drawPieChart();
      }
    });
  },

  watch: {
    reportDetailModel: {
      handler() {
        this.$nextTick(() => {
          if (this.chart) {
            this.drawPieChart();
          }
        });
      },
      deep: true
    }
  },

  methods: {
    drawPieChart() {
      // 确保数据存在，并正确处理百分比字符串
      const getPercentValue = (str) => {
        if (!str || str === 'NaN%' || str === 'NaN') return 0;
        const value = parseFloat(str.toString().replace('%', '').trim());
        return isNaN(value) ? 0 : value;
      };
      
      // 获取睡眠时间占比数据
      const lightPercent = getPercentValue(this.reportDetailModel?.lightMinutesTestPercentStr) ;
      const wakePercent = getPercentValue(this.reportDetailModel?.wakeMinutesTestPercentStr);
      const remPercent = getPercentValue(this.reportDetailModel?.remMinutesTestPercentStr) ;
      const deepPercent = getPercentValue(this.reportDetailModel?.deepMinutesTestPercentStr);
      
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            const value = params.value;
            if (value === 0 || isNaN(value)) {
              return params.name + ': 0%';
            }
            return params.name + ': ' + value + '%';
          }
        },
        grid: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
        color: this.colorArray,
        series: [
          {
            name: '睡眠时间占比',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'outside',
              formatter: function(params) {
                const value = params.value;
                if (value === 0 || isNaN(value)) {
                  return '0%\n' + params.name;
                }
                return value + '%\n' + params.name;
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: lightPercent, name: '浅睡' },
              { value: wakePercent, name: '清醒' },
              { value: remPercent, name: 'REM' },
              { value: deepPercent, name: '深睡' }
            ].map((item, index) => {
              // 设置文字颜色
              item.label = {
                color: this.colorArray[index],
                show: true,
                formatter: function(params) {
                  const value = params.value;
                  if (value === 0 || isNaN(value)) {
                    return '0%\n' + params.name;
                  }
                  return value + '%\n' + params.name;
                },
                position: 'outside'
              };
              return item;
            })
          }
        ]
      });
    }
  }
};
</script>
            
<style lang="scss" scoped>
.time-period-chart-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.sleep-pie-chart {
  width: 340px !important;
  height: 220px;
  box-sizing: border-box;
}

// 打印模式下调小饼图尺寸
@media print {
  .time-period-chart-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
  
  .sleep-pie-chart {
    width: 280px !important;
    height: 180px !important;
  }
}
</style>